import { common, message, auth } from "./common.mixin";
import { redirect } from "@/utils/"
export default function(Vue){
    Vue.mixin({
        ...common,
        ...auth,
        ...message,
        methods: {
            ...common.methods,
            ...message.methods,
            ...auth.methods,
            $$back(route){
                redirect(this.$route.query, this.$router)(route)
            }
        },
        computed: {
            ...common.computed,
            ...auth.computed,
            ...message.computed
        }
    });
}
